export default __webpack_public_path__ + "static/media/dicoding.84a4a167.png";